import * as React from "react";

const SvgPlusRules = (props) => (
  <svg
    width={30}
    height={30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#plus-rules_svg__a)">
      <path
        d="M16.5 13.5v-6h-3v6h-6v3h6v6h3v-6h6v-3h-6ZM15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="plus-rules_svg__a">
        <path fill="#fff" d="M0 0h30v30H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgPlusRules;
